import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './SocialMedia.css';

const SocialMedia = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" fill="currentColor"/>
        </svg>
      ),
      url: 'https://www.instagram.com/thecrappermapper?igsh=MW05bDA5NWdseWpjaw%3D%3D&utm_source=qr',
      description: 'Follow us for visual stories and clean restroom spots',
      color: '#e4405f'
    },
    {
      name: 'TikTok',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.36-4.08-1.1-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" fill="currentColor"/>
        </svg>
      ),
      url: 'https://www.tiktok.com/@thecrappermapper?_r=1&_t=ZP-93UEsPY1THK',
      description: 'Fun and informative restroom content',
      color: '#000000'
    },
    {
      name: 'Facebook',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="currentColor"/>
        </svg>
      ),
      url: 'https://www.facebook.com/TheCrapperMapper',
      description: 'Follow us for updates and community features',
      color: '#1877f2'
    }
  ];

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="social-media-page">
      <div className="social-header">
        <button className="back-button" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back
        </button>
        <h1>Connect With Us</h1>
        <p>Follow The Crapper Mapper on social media for updates, tips, and community features!</p>
      </div>

      <div className="social-grid">
        {socialLinks.map((social, index) => (
          <div 
            key={index} 
            className="social-card"
            onClick={() => handleSocialClick(social.url)}
            style={{ borderColor: social.color }}
          >
            <div className="social-icon" style={{ color: social.color }}>
              {social.icon}
            </div>
            <div className="social-info">
              <h3>{social.name}</h3>
              <p>{social.description}</p>
            </div>
            <div className="social-arrow">
              <ArrowLeft size={20} style={{ transform: 'rotate(-90deg)' }} />
            </div>
          </div>
        ))}
      </div>

      <div className="cta-section">
        <h3>Ready to Join?</h3>
        <button 
          className="signup-cta"
          onClick={() => window.location.href = '/auth'}
        >
          Doo Better!
        </button>
      </div>

      <div className="app-icon-center">
        <img src="/fullname-app-icon.png" alt="The Crapper Mapper" className="app-icon-large" />
      </div>

      <div className="social-footer">
        <div className="app-info">
          <div className="app-info-header">
            <img src="/fullname-app-icon.png" alt="The Crapper Mapper" className="app-icon" />
            <h2>The Crapper Mapper</h2>
          </div>
          <p>The #1 App for your #2 Needs</p>
          <p>Join our community of restroom reviewers and find the cleanest facilities near you!</p>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
